import BaseService from "./base.service";
const service = new BaseService("/projects/:id/sections")

service.bulkDeleteSections = function(payload){
  const path = this._getResource() + `/bulk_delete`
  return this.http.post(path, payload)
}

export default service;